module.exports = __webpack_public_path__ + "static/media/home_details.cd5f8093.png";